module.exports = __webpack_public_path__ + "static/media/background-remover.a559543b.png";